import React from "react";
import { InputNumber, Form } from "antd";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./number.module.scss";

export default function NumberField({
    width,
    label,
    classLabel,
    classInput,
    mandatory = true,
    type,
    ...rest
}) {
    const noteLabel = label => {
        return (
            <span>
                <span style={{ color: "red" }}>* </span>
                {label + ": "}
            </span>
        );
    };
    return (
        <div style={{display: "flex", justifyContent: "space-between", marginTop: "5px"}}>
            <div className={cx(styles.FormItem, classLabel)} style={{fontWeight: "600", fontSize: "13px", color: "#000000d9", width: "178px"}}>{mandatory ? noteLabel(label) : label + ": "}</div>
            <InputNumber
                type="number"
                style={{ width: width || "100%" }}
                className={cx(styles[type], styles.Input, classInput)}
                {...rest}
            />
        </div>
    );
}
NumberField.propTypes = {
    width: PropTypes.string,
};
